module.exports = __webpack_public_path__ + "f06ad331a3068f2a2b256df81cd8eb27.pdf";